<template>
  <div class="module-more">
    <div class="m-home-swiper">
      <div style="text-align:center">
        <!-- <img class="img-title" src="../../assets/images/home/pic_title5@2x.png" alt="" /> -->
      </div>

      <div class="swiper-box">
        <div class="swiper-container swiper-more-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in dataList" @click="goDetail(item)" :key="index">
              <div class="pic-box">
                <img v-lazy="item.imgUrl" alt="">
              </div>
              <div class="info">
                <h2 class="m-font-2 pf-regular">{{item.name}}</h2>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev swiper-button-white"></div>
          <div class="swiper-button-next swiper-button-black"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [
        {
          name: '数字展厅',
          imgUrl: require('@assets/images/more_1.jpg'),
          linkUrl: '/exhibition?type=4'
        },
        {
          name: '数字文物库',
          imgUrl: require('@assets/images/more_2.jpg'),
          linkUrl: '/collect/digital-culture'
        },
        {
          name: '民间文物鉴定',
          imgUrl: require('@assets/images/more_3.jpg'),
          linkUrl: '/identify'
        },
        {
          name: '成为志愿者',
          imgUrl: require('@assets/images/more_4.jpg'),
          linkUrl: '/education?type=3'
        },
        // {
        //   name: '成为志愿者',
        //   imgUrl: require('@assets/images/more_5.jpg'),
        //   linkUrl: '/exhibition'
        // },
        // {
        //   name: '儿童体验馆',
        //   imgUrl: require('@assets/images/more_6.jpg'),
        //   linkUrl: '/exhibition'
        // },
      ],
      redList: [],
      listQuery: {
        currentPage: 1,
        size: 10,
      },
    };
  },

  mounted() {
    this.initSwiper()
    // this.getDataList()
  },

  methods: {
    initSwiper() {
      this.$nextTick(() => {
        let swiper = new Swiper(".module-more .swiper-container.swiper-more-container", {
          // autoplay: 5000,
          slidesPerView: 1.8,
          spaceBetween: 20,
          observer: true,
          observeParents: true,
          prevButton: '.module-more .swiper-button-prev',
          nextButton: '.module-more .swiper-button-next',
        })
      })
    },

    getDataList() {
      this.listLoading = true
      this.$http
        .get('/public/index.do', {
          ...this.listQuery
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.redList = res.data.Carousels
            this.initSwiper()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    goDetail(item) {
      this.$router.push({
        path: item.linkUrl
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.module-more {
  // .swiper-box {
  //   width: 1200px;
  //   margin: 0 auto;
  //   display: flex;
  //   position: relative;
  // }

  .swiper-wrapper {
    position: inherit;
    // display: flex;
    // flex-wrap: wrap;
  }

  .swiper-container {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .swiper-slide {
    position: relative;
    // width: 50%;
    // padding: 10px;
    // box-sizing: border-box;

    // flex-basis: 285px;
    // flex-shrink: 0;
    // height: 285px;
    font-size: 18px;
    transition: 300ms;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    &:hover img{
      transform: scale(1.02);
    }
    .pic-box {
      flex-shrink: 0;
      box-sizing: border-box;
      position: relative;
      height: 440px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.6s;
        object-fit: cover;
      }
    }

    .info {
      position: absolute;
      left: 30px;
      bottom: 30px;
      // font-size: 30px;
      font-weight: bold;
      letter-spacing: 2px;
      color: #fff;
    }
  }
}
</style>